export const SCOPE = 'sharedTabs';

export const INIT = `${SCOPE}/INIT`;
export const UPDATE_SHARED_TABS = `${SCOPE}/UPDATE_SHARED_TABS`
export const ADD_NEW_SHARED_TAB = `${SCOPE}/ADD`;
export const DELETE_SHARED_TAB = `${SCOPE}/DELETE`;
